import { withControlledField } from '../ControlledField';
import { SwitchFieldWrapper } from './SwitchFieldWrapper';

export const ControlledSwitchField = withControlledField(SwitchFieldWrapper);
